export default function KontaktHero() {
  return (
    <section className="relative min-h-[420px] md:min-h-[520px] flex items-end overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/123ced1a2ac8a0df5933117957517cb3.jpg"
        alt="Kontakt IGM Facility Service"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0D2B4E]/90 via-[#0D2B4E]/50 to-[#0D2B4E]/20" />

      <div className="relative w-full pb-12 pt-32 md:pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-[2px] bg-[#C8A96E]" />
              <span className="text-[#C8A96E] text-sm font-semibold tracking-widest uppercase">Kontakt</span>
            </div>
            <h1 className="text-3xl sm:text-5xl font-bold text-white mb-4 leading-tight">
              Ihr Projekt beginnt<br />mit einem Gespräch
            </h1>
            <p className="text-white/80 text-base sm:text-lg max-w-xl leading-relaxed">
              Schildern Sie uns Ihr Vorhaben – wir erstellen Ihnen ein kostenloses,
              unverbindliches Festpreisangebot innerhalb von 24 Stunden.
            </p>

            <div className="flex flex-wrap gap-6 mt-8">
              <div className="flex items-center gap-2 text-white/90">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-[#C8A96E] text-lg" />
                </div>
                <span className="text-sm font-medium">Kostenlose Beratung</span>
              </div>
              <div className="flex items-center gap-2 text-white/90">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-[#C8A96E] text-lg" />
                </div>
                <span className="text-sm font-medium">Antwort in 24h</span>
              </div>
              <div className="flex items-center gap-2 text-white/90">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-[#C8A96E] text-lg" />
                </div>
                <span className="text-sm font-medium">Transparentes Festpreisangebot</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
